import { bgColors } from '../../utils/bgColor';
import mapboxgl from 'mapbox-gl';

 export function addStartPointlayer (map,startcoords){
    const start = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Point',
              coordinates: startcoords
            }
          }
        ]
      };
      if (map.getLayer('start')) {
        map.getSource('start').setData(start);
        // map.flyTo({
        //   center: [startcoords.longitude, startcoords.latitude],
        //   speed: 0.5
        //   });
      }
      else{
        map.addLayer({
            id: 'start',
            type: 'circle',
            source: {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                      type: 'Point',
                      coordinates: startcoords
                    }
                  }
                ]
              }
            },
            paint: {
              'circle-radius': 10,
              'circle-color': bgColors.blue_500
            }
          });
          // map.flyTo({
          //   center: [startcoords.longitude, startcoords.latitude],
          //   speed: 0.5
          //   });
          
      }
      
 }


 export function addEndPointlayer (map,endcoords){
    const end = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Point',
              coordinates: endcoords
            }
          }
        ]
      };
      if (map.getLayer('end')) {
          map.getSource('end').setData(end); 
      }
      else{
        map.addLayer({
            id: 'end',
            type: 'circle',
            source: {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                      type: 'Point',
                      coordinates: endcoords
                    }
                  }
                ]
              }
            },
            paint: {
              'circle-radius': 10,
              'circle-color': bgColors.red_900
            }
          });
       
      }
 }



  export async function Routelayer(map,routecord){
    const geojson = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: routecord
      }
    };
  
      if (map.getLayer('routelayer')) {
          map.getSource('routelayer').setData(geojson);
       }
      else{
        map.addLayer({
          id: 'routelayer',
          type: 'line',
          source: {
            type: 'geojson',
            data: geojson
          },
          layout: {
            'line-join': 'round',
            'line-cap': 'round'
          },
          paint: {
            'line-color': bgColors.yellow_500,
            'line-width': 6,
            'line-dasharray': [0, 1.5],
            // 'line-opacity': 0.75
          }
        });
      }
    if (map.getLayer('routelayer_point')) {
        map.getSource('routelayer_point').setData(geojson);
     }
     else{
        map.addLayer({
          id: 'routelayer_point',
          type: 'circle',
          source: {
            type: 'geojson',
            data: geojson
          },
          paint: {
            'circle-color':  bgColors.grey_300,
            'circle-radius': 5,
          },
        });
      }
 }



export function updateRoutelayer(map,geojson){
  
  if (map.getLayer('routelayer')) {
    map.getSource('routelayer').setData(geojson);
  }
  if (map.getLayer('routelayer_point')) {
    map.getSource('routelayer_point').setData(geojson);
  }
  // if (map.getLayer('routelayer_point')) {
  //   map.getSource('routelayer_point').setData(geojson);
  // }
 }


//  export function handleWaterbodylayer(map,WaterBodies){
//   const source_id = "india_waterpoly"
//   const layer_id =  "india_waterpoly"
//   if(WaterBodies===false){
//     if (map.getLayer(layer_id)) {
//         map.removeLayer(layer_id);
//       }
//     if (map.getSource(source_id)) {
//          map.removeSource(source_id);
//       }
//   }
// }







//  export default addStartPointlayer


 